import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";


const initialState = {
    data: new Array<Member>(),
};


const loadLocalMedia = async (isVideoOn: boolean, isAudioOn: boolean): Promise<MediaStream | undefined> => {
    const constraints = {
        video: true,
        audio: true,
    }

    if (isAudioOn === false && isVideoOn === false) {
        constraints.video = true;
    }
    try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        return stream;
    } catch (err) {
        return undefined;
    }
}


export const asyncUpdateLocalMedia = createAsyncThunk('members/updateLocalMedia', async (mediaSetting: { is_video_on: boolean, is_audio_on: boolean }, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;
    const localMember = rootState.members.data.find((member) => member.is_local === true);
    if (localMember === undefined) {
        return
    }
    const mediaStream = await loadLocalMedia(mediaSetting.is_video_on, mediaSetting.is_audio_on);
    thunkAPI.dispatch(updateMedia({ pubkey: localMember.pubkey, is_video_on: mediaSetting.is_video_on, is_audio_on: mediaSetting.is_audio_on, stream: mediaStream }));
})

export const asyncAddMember = createAsyncThunk('members/asyncAddMember', async (member: Member, thunkAPI) => {
    if (member.is_local === true) {
        const mediaStream = await loadLocalMedia(member.is_video_on ?? true, member.is_audio_on ?? true);
        member.stream = mediaStream;
    }
    if (member.stream === undefined) {
        member.stream = new MediaStream();
    }
    thunkAPI.dispatch(addMember(member));
})



export const asyncAddMediaStreamTrack = createAsyncThunk('members/asyncAddMediaStreamTrack', async (mediaStrackInfo: {
    pubkey: string
    mediaStreamTrack: MediaStreamTrack
}, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;
    const member = rootState.members.data.find((member) => member.pubkey === mediaStrackInfo.pubkey);
    if (member === undefined) {
        return
    }
    const mediaStream = member.stream ?? new MediaStream();
    mediaStream?.addTrack(mediaStrackInfo.mediaStreamTrack);
    thunkAPI.dispatch(updateMediaStream({ pubkey: mediaStrackInfo.pubkey, stream: mediaStream }));
})

const membersSlice = createSlice({
    name: "members",
    initialState,
    reducers: {
        addMember(state, action) {
            const existingMember = state.data.find(member => member.pubkey === action.payload.pubkey);
            if (existingMember) {
                Object.assign(existingMember, action.payload);
            } else {
                state.data.push(action.payload);
            }
        },
        removeMember(state, action) {
            state.data = state.data.filter(member => member.pubkey !== action.payload.pubkey);
        },
        updateMember(state, action) {
            const member = state.data.find(member => member.pubkey === action.payload.pubkey);
            if (member) {
                Object.assign(member, action.payload);
            }
        },
        updateMedia(state, action) {
            const member = state.data.find(member => member.pubkey === action.payload.pubkey);
            if (member) {
                if (action.payload.is_audio_on !== undefined) {
                    member.is_audio_on = action.payload.is_audio_on;
                }
                if (action.payload.is_video_on !== undefined) {
                    member.is_video_on = action.payload.is_video_on;
                }
                if (action.payload.stream !== undefined) {
                    member.stream = action.payload.stream;
                }
            } else {
                state.data.push(action.payload);
            }
        },
        updateMediaStream(state, action) {
            const member = state.data.find(member => member.pubkey === action.payload.pubkey);
            if (member) {
                member.stream = action.payload.stream;
            }
        }
    },

});

export const { addMember, removeMember, updateMember, updateMedia, updateMediaStream } = membersSlice.actions;
export default membersSlice.reducer;